import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import { StatusIndicator } from '../../../../components/status-indicator';
import { InfoIcon } from '../../../../components/info-icon';
import { thousandSeparator } from '../../../reqs-details-modal/utils';

const CarrierModalCustomCell = ({ rowData, columnId, isLoading, isSending }) => {
	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const history = useHistory();

	const handleCustomCellButtonClick = id => {
		query.set('carrier-id', id);
		query.set('modal', 'carrier-approval');
		history.push(`${pathname}?${query}`);
	};

	if (columnId === 'company') {
		if (rowData.is_show) {
			return (
				<Link className="carrier-modal-custom-cell__company" to={rowData.company.link}>
					<div className="carrier-modal-custom-cell__contact-name">{rowData[columnId].name}</div>
					<div className="carrier-modal-custom-cell__company-code">{rowData[columnId].inn}</div>
				</Link>
			);
		}

		return (
			<div className="carrier-modal-custom-cell__company">
				<div className="carrier-modal-custom-cell__contact-name">{rowData[columnId].name}</div>
				<div className="carrier-modal-custom-cell__company-code">{rowData[columnId].inn}</div>
			</div>
		);
	}

	if (columnId === 'price_with_tax') {
		return (
			<div className="carrier-modal-custom-cell__price">
				<span className="carrier-modal-custom-cell__price-label">
					{thousandSeparator(rowData.price_with_tax)}
				</span>
			</div>
		);
	}

	if (columnId === 'info_with_tax') {
		return (
			<div className="carrier-modal-custom-cell__price">
				{rowData.info_with_tax && (
					<div className="carrier-modal-custom-cell__price-info">
						<InfoIcon popupContent={rowData.info_with_tax} />
					</div>
				)}
			</div>
		);
	}

	if (columnId === 'price') {
		return (
			<div className="carrier-modal-custom-cell__price">
				<span className="carrier-modal-custom-cell__price-label">{thousandSeparator(rowData.price)}</span>
			</div>
		);
	}

	if (columnId === 'info') {
		return (
			<div className="carrier-modal-custom-cell__price">
				{rowData.info && (
					<div className="carrier-modal-custom-cell__price-info">
						<InfoIcon popupContent={rowData.info} />
					</div>
				)}
			</div>
		);
	}

	if (columnId === 'date') {
		return (
			<div className="carrier-modal-custom-cell__date">
				{rowData.status && (
					<div className="carrier-modal-custom-cell__date-status-indicator">
						<StatusIndicator status={rowData.status} />
					</div>
				)}
				<span className="carrier-modal-custom-cell__date-label">{rowData.date}</span>
			</div>
		);
	}

	if (columnId === 'action') {
		if (!rowData.isActionButtonVisible) {
			return null;
		}

		return (
			<Button
				disabled={isLoading || isSending}
				className="carrier-modal-custom-cell__button"
				onClick={() => handleCustomCellButtonClick(rowData.id)}
			>
				Выбрать
			</Button>
		);
	}

	return rowData[columnId];
};

CarrierModalCustomCell.propTypes = {
	rowData: PropTypes.object.isRequired,
	columnId: PropTypes.string.isRequired,
	isLoading: PropTypes.bool.isRequired,
	isSending: PropTypes.bool.isRequired,
};

export { CarrierModalCustomCell };
